
var seminarWrapper = document.querySelector(".dd-overview");
var seminarTrigger = document.querySelectorAll(".tabs__link");
var calendarTrigger = document.querySelector(".tabs__link--calendar");
var listTrigger = document.querySelector(".tabs__link--list");

if (seminarWrapper) {
  calendarTrigger.onclick = function () {
    seminarWrapper.classList.remove('list-open');
    seminarWrapper.classList.add('calendar-open');
    calendarTrigger.classList.add('is-active');
    listTrigger.classList.remove('is-active');
  };

  listTrigger.onclick = function () {
    seminarWrapper.classList.remove('calendar-open');
    seminarWrapper.classList.add('list-open');
    listTrigger.classList.add('is-active');
    calendarTrigger.classList.remove('is-active');
  };
}


